import React from 'react';
import { concatClassName } from '@dateam/ark-react';
import propTypes from 'prop-types';
import styles from './Page.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const PageHeaderActions: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <div className={concatClassName(styles['header-actions'], className)}>
        {children}
    </div>
);

PageHeaderActions.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

PageHeaderActions.defaultProps = {
    className: undefined,
    children: undefined
};

export default PageHeaderActions;
